import React from 'react';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import UserAvatar from '@components/UserAvatar';
import useSx from './sx';

type Props = {
  userFullName: string;
  profilePhoto: string;
};

const UsersCell = ({ userFullName, profilePhoto }: Props) => {
  const sx = useSx();

  return (
    <TableCell className="user-col">
      <Box width="100%" display="flex" alignItems="center" justifyContent="center" gap="10px">
        <UserAvatar sx={sx.root} userFullName={userFullName} userProfilePhoto={profilePhoto} />
        <Typography fontSize="0.8rem" flex="1">
          {userFullName}
        </Typography>
      </Box>
    </TableCell>
  );
};

export default UsersCell;
